/** 从表单/选型元数据解析提交用 ID（兼容 vendorId/deviceId 读入） */
function resolveVendorDeviceSubmitIds(
  meta?: {
    vendorID?: string;
    deviceID?: string;
    vendorId?: string;
    deviceId?: string;
  } | null,
): { vendorID?: string; deviceID?: string } {
  const vendorID = String(meta?.vendorID ?? meta?.vendorId ?? '').trim() || undefined;
  const deviceID = String(meta?.deviceID ?? meta?.deviceId ?? '').trim() || undefined;
  return {
    ...(vendorID ? { vendorID } : {}),
    ...(deviceID ? { deviceID } : {}),
  };
}

/** 展示用厂商/设备名称（不参与 ID 提交语义） */
function resolveVendorDeviceDisplay(meta?: { vendor?: string; device?: string } | null): {
  vendor?: string;
  device?: string;
} {
  const vendor = String(meta?.vendor ?? '').trim() || undefined;
  const device = String(meta?.device ?? '').trim() || undefined;
  return {
    ...(vendor ? { vendor } : {}),
    ...(device ? { device } : {}),
  };
}

/**
 * resourceConfigs / 计价等提交：vendor/device（名称）与 vendorID/deviceID（ID）均可写入；
 * 禁止把展示名回填进 vendorID/deviceID。
 */
export function toVendorDeviceSubmitFields(
  meta?: {
    vendor?: string;
    device?: string;
    vendorID?: string;
    deviceID?: string;
    vendorId?: string;
    deviceId?: string;
  } | null,
): {
  vendor?: string;
  device?: string;
  vendorID?: string;
  deviceID?: string;
} {
  return {
    ...resolveVendorDeviceDisplay(meta),
    ...resolveVendorDeviceSubmitIds(meta),
  };
}

/**
 * deliveryMetadata 提交字段：仅 vendorID / deviceID。
 * vendor / device 为展示名，只应留在表单与 optionMeta，禁止写入 deliveryMetadata。
 */
export function toVendorDeviceDeliveryFields(
  meta?: {
    vendor?: string;
    device?: string;
    vendorID?: string;
    deviceID?: string;
    vendorId?: string;
    deviceId?: string;
  } | null,
): {
  vendorID?: string;
  deviceID?: string;
} {
  return resolveVendorDeviceSubmitIds(meta);
}
